import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.eventFilter = this.element.querySelector("select[name='investigation_candidates_grid[event_id]']")
    this.selectedEventId = this.eventFilter?.value
    this.initialFilters = this.filterSelection()
  }

  refresh(event) {
    this.invalidateInitialization(event)
    if (event.target !== this.eventFilter || this.eventFilter.value === this.selectedEventId) return

    this.selectedEventId = this.eventFilter.value
    this.eventFilter.form.requestSubmit()
  }

  invalidateInitialization(event) {
    if (!this.eventFilter || event.target.form !== this.eventFilter.form) return
    if (this.filterSelection() === this.initialFilters) return

    const createButton = document.getElementById("screening_prefecture_submit")
    if (createButton) {
      createButton.disabled = true
      createButton.dataset.screeningInitialized = "false"
    }
  }

  filterSelection() {
    if (!this.eventFilter?.form) return ""

    const values = Array.from(new FormData(this.eventFilter.form)).filter(([name, value]) => {
      const filter = name.match(/^investigation_candidates_grid\[([^\]]+)\]/)?.[1]
      return filter && !["order", "descending", "orders"].includes(filter) && value !== ""
    })
    return JSON.stringify(values.sort())
  }
}
